import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Guide16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6.85706 10.775L11.3874 6.24463L10.3267 5.18397L6.85706 8.65364L5.10168 6.89825L4.04102 7.95891L6.85706 10.775Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.15715 1.26666C0.697518 1.16817 0.25 1.52995 0.25 2.00002V12.5C0.25 12.8537 0.49705 13.1593 0.842853 13.2334L7.84285 14.7334C7.94644 14.7556 8.05356 14.7556 8.15715 14.7334L15.1571 13.2334C15.5029 13.1593 15.75 12.8537 15.75 12.5V2.00002C15.75 1.52995 15.3025 1.16817 14.8429 1.26666L8 2.73299L1.15715 1.26666ZM1.75 11.8937V2.92776L7.84285 4.23337C7.94644 4.25556 8.05356 4.25556 8.15715 4.23337L14.25 2.92776V11.8937L8 13.233L1.75 11.8937Z'
      fill='currentColor'
    />
  </Svg>
);

Guide16.displayName = 'Guide16';
export default Guide16;
